import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import IconClose from './IconClose';
import './index.scss';

interface EfDialogYoutubeProps {
    /**
     * 是否开启弹窗
     */
    open: boolean;
    /**
     * youtube 视频链接
     */
    src: string;
    /**
     * 关闭回调
     */
    callback?: () => void;
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护:谢保林
 *
 * youtube 视频弹窗
 */
const EfDialogYoutube: React.FC<EfDialogYoutubeProps> = ({ open, src, callback, className }) => {
    const prefixCls = `ef-dialog-youtube`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const refDialog = useRef<any>(null);

    useEffect(() => {
        if (open) {
            refDialog.current.showModal();
        }
    }, [open]);

    // 关闭
    const closeHandle = () => {
        refDialog.current.close();
        callback && callback();
    };

    return (
        <dialog className={classes} ref={refDialog}>
            <div className={`${prefixCls}-in`}>
                <iframe className={`${prefixCls}-iframe`} src={src}></iframe>
            </div>
            <button className={`${prefixCls}-close`} onClick={closeHandle}>
                <IconClose />
            </button>
        </dialog>
    );
};

export default EfDialogYoutube;
